import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  IconButton, 
  Box 
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { Event } from '@/types/events';
import { EventTabs } from './EventTabs';

interface EventDialogProps {
  event: Event | null;
  open: boolean;
  onClose: () => void;
  onUpdate: (updatedEvent: Event) => void;
}

export const EventDialog: React.FC<EventDialogProps> = ({
  event,
  open,
  onClose,
  onUpdate
}) => {
  if (!event) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      fullScreen
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box component="span" sx={{ typography: 'h6' }}>
            {event.title}
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
        <EventTabs event={event} onUpdate={onUpdate} />
      </DialogContent>
    </Dialog>
  );
};